import css from 'styled-jsx/css';

export default css`
  .image-snippet-modal {
    width: 100%;
    height: 100%;
  }
`;



// WEBPACK FOOTER //
// ./app/common/ImageSnippetModal/styles.js